import { Fragment } from 'react'
import Grid from '@mui/material/Grid'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Box, Container } from '@mui/material'
import { Link } from 'react-router-dom'
import { formatter } from '../../utils/auxFunc'
import './SuggestedProducts.css'

function SuggestedProducts({ product, showPriceAndLogin }) {
  return (
    <Container
      sx={{
        marginBottom: '50px',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center'
      }}
    >
      <Fragment>
        {product.webRelatedProducts?.slice(0, 3).map((product) => (
          <Grid
            className="grid-suggested-products"
            container
            key={product.idProduct}
            xs={6}
            sm={6}
            md={3}
            xl={3}
          >
            <Link
              className="linkGridHome"
              to={`/itemDetail/${product.idProduct}`}
              target="_blank"
            >
              <CardMedia
                className="imgGridSuggestedProducts"
                component="img"
                // height="40%"
                image={product.img}
                alt={product.productName}
              />
              <Box component="article" sx={{ padding: '1rem' }}>
                <Typography
                  className="nameCard"
                  sx={{ textAlign: 'left' }}
                  variant="body1"
                >
                  {`${product.productName}`}
                </Typography>
                <Typography
                  className="nameCard"
                  sx={{ textAlign: 'left' }}
                  variant="body1"
                >
                  {`SKU: ${product.sku}`}
                </Typography>
                <Typography
                  sx={{
                    textAlign: 'left',
                    fontWeight: 'bold'
                  }}
                  color="text.primary"
                  variant="h3"
                >
                  {showPriceAndLogin &&
                    formatter().format(product.price * product.dolarValue)}
                </Typography>
              </Box>
            </Link>
          </Grid>
        ))}
      </Fragment>
    </Container>
  )
}

export default SuggestedProducts
